
export interface BaseSuccessJSON {
  status: string;
  message: string;
}

export class BaseSuccessModel {
  status: string;
  message: string;

  constructor(
    status: string,
    message: string
  ) {

    this.status = status;
    this.message = message;
  }
}


export class BaseSuccessFactory {

  fromJSON(json: BaseSuccessJSON): BaseSuccessModel {
    return new BaseSuccessModel(
      json.status,
      json.message
    );
  }

  toJSON(model: BaseSuccessModel): BaseSuccessJSON {
    return {
      status: model.status,
      message: model.message
    };
  }
}
